import { useEffect } from 'react';

const BODY_CLASS = 'lens-overlay-open';

/**
 * Hides iubenda cookie UI and Help Scout beacon while a modal/drawer is open.
 * Those widgets sit at max z-index and can steal keyboard focus from in-app editors.
 */
export function useSuppressThirdPartyWidgets(active) {
    useEffect(() => {
        if (!active) return undefined;

        document.body.classList.add(BODY_CLASS);
        return () => document.body.classList.remove(BODY_CLASS);
    }, [active]);
}
